<template>
	<v-row
		justify="center"
		align="center"
	>
		<v-col
			xl="10"
			lg="11"
			md="12"
			sm="12"
			cols="12"
		>
			<v-card outlined>
				
				<v-card-title
					class="pa-1 secondary  body-1 "
				>	
					<v-icon
						small		
						color="success"
						class="mx-1"				
						v-text="'mdi-shield-check'"
					></v-icon>
					<span
						v-text="'Access Rules'"
					></span>
					<v-spacer></v-spacer>
					<v-btn
						class="mt-10 mr-5"
						right
						x-small
						fab
						absolute
						:color="!show ? 'blue darken-1' : 'error'"
						@click="show = !show"
					>
						<v-icon
							x-small							
						>
							{{ !show ? 'mdi-plus' : 'mdi-close'}}
						</v-icon>
					</v-btn>
					<v-icon 
						
						color  = "white"
						class  = "ml-1 "
						@click = "$router.back()"
						v-text = "'mdi-arrow-left-circle'"
					></v-icon>
				</v-card-title>
				<v-card-text class="mt-3">
					<v-row>
						<v-col
							xl="3"
							lg="3"
							md="4"
							sm="5"
							xs="12"
							cols="12"
							v-show="show"
						>
							<v-card outlined>
								<v-card-title
									class="body-2 pa-1 primary"
									v-text="subtitle"
								>									
								</v-card-title>
								<v-card-text class="pt-1">
									<v-row
										no-gutters
									>
										
										<template 
											v-for="(item_field, idx_field) of info_fields"
										>
											<v-col 
												:cols ="item_field.type == 'switch' ? 6 : 12"
											>
												<v-text-field
													v-if 		 = "item_field.type == 'text' || item_field.type == 'number'"
													:type 		 = "item_field.type"
													v-model 	 = "info[item_field.key]"
													:label 		 = "$ml.get(item_field.text)"
													dense
													outlined		
													hide-details									
													class 		 = "my-1"
													:placeholder = "item_field.type == 'number' ? 'seg' : ''"
												>
													<v-icon
														v-if 	 = "item_field.key == 'timeout' || item_field.key == 'alertTime'"
														small
														slot 	 = "append"
														color 	 = "primary"
														v-text 	 = "'mdi-timer'"
													></v-icon>
												</v-text-field>	
												<v-switch
													v-if 		 = "item_field.type == 'switch'"
													v-model 	 = "info[item_field.key]"			
													:label 		 = "$ml.get(item_field.text)"
													hide-details
												></v-switch>
												<v-select
													v-if 	  	= "item_field.type == 'select'"
													v-model   	= "info[item_field.key]"			
													:label 	  	= "$ml.get(item_field.text)"
													hide-details
													:items 	  	= "render_listeds(item_field.list)"
													:item-text 	= "item_field.item_text"											
													:item-value = "item_field.item_value" 
													outlined
													dense
													class		= "mt-1"
												></v-select>
											</v-col>
										</template>
									</v-row>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn			
										x-small							
										color="primary"
										@click="actions(btn_title)"
									>
										{{ $ml.get(btn_title) }}
									</v-btn>
									<v-btn
										x-small							
										color="error"
										v-text="$ml.get('close')"
										@click="actions('close_show') "
									></v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col
							:xl="show ? 9 : 12"
							:lg="show ? 9 : 12"
							:md="show ? 8 : 12"
							:sm="show ? 7 : 12"
							xs="12"
							cols="12"
						>
							
							<v-toolbar						    		
						    		dense
						    		height="25"
						    	>
						    	<v-toolbar-title 
						    		class="body-2"
						    	>Registered Access</v-toolbar-title>
						    </v-toolbar>
								
							<v-divider></v-divider>
							<v-data-table
								dense
							    :headers    		 = "headers"
							 	:items 				 = "render_list"
							    class 				 = "elevation-5"			    
							    :hide-default-footer = "height < 56 ?  true : false"
							   	:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	:footer-props 		 = "{
							   		showFirstLastPage: true,
							   		itemsPerPageOptions: [15, 30],
							   		showCurrentPage: true
							   	}"				   	
							    :height 			 = "height + 'px'"
							    fixed-header
							    item-key 			 = "index"
							>
								<template v-slot:item.isAccess="{ item }">
									<v-btn
								        small
								        :color 		= "item.isAccess == '1' ? 'primary' : 'secondary'"						       
								        class 		= "pa-0"
								        @click.stop = "update(item, 'access')"
								        v-model 	= "item.isAccess"
								        dense
								        hide-details
								        
								    >				
								    	{{ item.isAccess == '1' ? 'ON' : 'OFF' }}       
								    </v-btn>
								</template>
								<template  v-slot:item.isActive="{ item }">
									
								    <v-btn
								        small
								        :color 		= "item.isActive == '1' ? 'info' : 'secondary'"					        
								        class 		= "pa-0"
								        @click.stop = "update(item, 'active')"
								        v-model 	= "item.isActive"
								        dense
								        hide-details
								        
							    	>				 
							    		{{ item.isActive == '1' ? 'ON' : 'OFF' }}
									</v-btn>
								</template>
								<template v-slot:item.isPopup="{ item }">
									<v-btn
								        small
								        :color="item.isPopup=='1' ? 'primary' : 'secondary'"
								        class="pa-0"
								        @click.stop="update(item, 'popup')"
								        v-model="item.isPopup"
								        dense
								        hide-details
								        
								    >				
								    	{{ item.isPopup=='1' ? 'ON' : 'OFF' }}       
								    </v-btn>
								</template>
								<template  v-slot:item.isSound="{ item }">
									
								    <v-btn
								        small
								        :color="item.isSound=='1' ? 'info' : 'secondary'"					        
								        class="pa-0"
								        @click.stop="update(item, 'sound')"
								        v-model="item.isSound"
								        dense
								        hide-details
								        
							    	>				 
							    		{{ item.isSound=='1' ? 'ON' : 'OFF' }}
									</v-btn>
								</template>
								<template  v-slot:item.actions = "{ item }">
									<v-icon
								        small
								        color  = "primary"
								        class  = "mr-2"
								        @click = "edit(item)"
								      >
								        mdi-pencil
								      </v-icon>
								      <v-icon
								        small
								        color  = "error"
								        @click = "del(item)"
								      >
								        mdi-delete
								      </v-icon>
								</template>
								<template v-slot:item.timeout = "{ item }">
									
									<v-icon
										small						
										color  = "primary"
										v-text = "'mdi-timer'"
										@click = "edit_timeout(item)"
									></v-icon>
									<span 
										v-text = "item.timeout"
										class  = "col-md-2 mr-1"
									></span>
									<span
										class  = "secondary--text"
										v-text = "'seg'"
									></span>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
				<notifications
					v-if="info_to_modal"
					:info="info_to_modal"
					@confirm_message="confirm_del($event)"
					@close_snack_dialog="info_to_modal=$event"
				></notifications>
				<v-dialog 
					v-model="dialog_timer"
					width="300"
				>
					<v-card outlined>
						<v-card-title
							v-text="$ml.get('timeout')"
							class="justify-center body-2 primary pa-1"
						></v-card-title>
						<v-card-text class="pb-0">
							<v-row >
								<v-col md="8">
									<v-text-field
										v-model.number="update_item.timeout"
										type="number"
										dense
										hide-details
										:label="$ml.get('seconds')"
									></v-text-field>
								</v-col >
								<v-col md="2" class="pt-1">
									<v-btn 
										x-small
										@click="update_item.timeout++"
									>
										<v-icon
											x-small
											color="primary"
											v-text="'mdi-sort-clock-descending'"
										></v-icon>
									</v-btn>
									<v-btn 
										x-small
										@click="update_item.timeout > 0 ? update_item.timeout-- : 0"
									>
										<v-icon
											x-small
											color="error"
											v-text="'mdi-sort-clock-ascending'"
										></v-icon>
									</v-btn>
								</v-col>
							</v-row>

						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color  = "primary"
								x-small
								v-text = "$ml.get('save')"
								@click = "update(update_item, 'timeout')"
							></v-btn>
							<v-btn
								color  = "error"
								x-small
								v-text = "$ml.get('close')"
								@click = "dialog_timer=false"
							></v-btn>

						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
import notifications 	from '@/components/info/notifications.vue'
import eventBus 		from '@/event-bus'
import axios 			from 'axios'
axios.defaults.withCredentials = false;

	export default{
		name: 'access_rules',
		components:{
			notifications
		}, // components
		
		data: vm => ({
			info 		: {},
			info_fields : [
				{
					key 	   : 'host',
					text 	   : 'device',
					type 	   : 'select',
					list 	   : 'list_devices',
					item_text  : 'name',
					item_value : 'deviceId',

				},
				{
					key: 'entity',
					text: 'name',
					type: 'select',
					list: 'list_trained',
					item_text  : 'name',
					item_value : 'name',
				},
				
				{
					key: 'timeout',
					text: 'popup_timeout',
					type: 'number',
					
				},
				{
					key: 'isAccess',
					text: 'access',
					type: 'switch',
					
				},
				{
					key: 'isActive',
					text: 'active',
					type: 'switch',
					
				},
				{
					key: 'isSound',
					text: 'sound',
					type: 'switch',
					
				},
				{
					key: 'isPopup',
					text: 'popup',
					type: 'switch',
					
				},
			],
			headers:[
				// { text: vm.$ml.get('id'), value: 'id', align: 'center' },
				{ text: vm.$ml.get('device'), value: 'device_name', align: '' },
				{ text: vm.$ml.get('name'), value: 'entity', align: '' },				
				{ text: 'Access'/*vm.$ml.get('sounds')*/, value: 'isAccess', align: '' },
				{ text: vm.$ml.get('active'), value: 'isActive', align: '' }, 
				{ text: vm.$ml.get('pop_ups'), value: 'isPopup', align: '' },
				{ text: vm.$ml.get('sounds'), value: 'isSound', align: '' },
				{ text: vm.$ml.get('timeout'), value: 'timeout', align: '' }, 
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center' }, 
			],
			list: [],
			height: 350,
			options: {itemsPerPage: 30},
			total: 1,
			del_item: 0,
			is_show: false,
			update_item: '',
			info_to_modal: null,		
			dialog_timer: false,
			timer: 0,
			name_change: '',
			show: false,
			subtitle: 'New Access Rule',
			btn_title : 'save',
			list_devices : [],
			list_trained : [],
		}), // data
		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true, 
			}, // options
			
		}, // watch

		created(){
			this.get_list_trained();
		}, // created

		methods: {
			actions(act, item, opt){
				if (act == 'save') {
					this.save();
				}else if( act == 'update'){
					this.update(this.update_item, 'settings');
				}else if( act == 'close_show'){
					this.show = false;
				}
			}, // actions

			render_listeds:function (opt){
				if (this[opt]) {
					return this[opt]
				}
				return [];

			}, // render listeds

			async get_list(){
				const { page, itemsPerPage } = this.options;
				let pg = 1, 
					sw = 0;
				if (itemsPerPage == 15) {
					if (page % 2 == 0) {
						pg = (page / 2);
						sw = 2;
					}else{
						pg = parseInt(page / 2) + 1;
						sw = 1;
					}
				}else{
					pg = page
				}
				let pages = 2,
		          	lists  = []; 

		        while (pg < pages){
					const api = this.$URL_face + '/api/face/ruleaccess?page=' + pg;
					// /?page= + pg 
					const listed = await axios.get(api).then( res => {
						let item  	= res.data;
						let items 	= item.results;
						this.total 	= parseInt(item.count);
						/*if (itemsPerPage <= 15) {
							items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
						}	*/			


						let vm = this;
						items.forEach( (access) => {
							if (access.host) {
								access.device_name =  vm.render_device(access.host);
							}
						})
						if (res.data.next){
		                  pages++;              
		                }
						
						if (pg == 1) {			                
			                lists = items;
			            }else{
			                lists = lists.concat(items)
			            }

			            return lists;

						
					}).catch( er =>{
						console.log(er, 'error get list sz_contacts')
					})
					pg ++
				} // while

				if (lists && lists.length > 0) {
					this.list = lists;
					this.save_local();
				}
			}, // get list

			async get_list_trained(){
				let page  = 1,
		          	pages = 2,
		          	list  = []; 

		        while (page < pages){

					const api = this.$URL_face + '/api/face/list?page=' + page;
					
					const listed =  await  
					axios.get(api).then( res => {
						
						let items 	= res.data.results;
		            	if (res.data.next){
		                  pages++;              
		                }
						
						if (page == 1) {			                
			                list = items;
			            }else{
			                list = list.concat(items)
			            }

			            return list;
						
					}).catch( er =>{
						console.log(er, 'error get list trained')
					})
					page++;		        
		    	}
		       	
		       	if (list && list.length > 0) {     
		       		this.list_trained = list;
		       	}
			}, // get_list_trained

			save(){
				
				
				// 
					let info_to_up  = this.info;
					let info_update = {
						entity 		: info_to_up.entity,
						host 		: info_to_up.host,
						isAccess    : info_to_up.isAccess, //? 'true' : 'false',
						isActive 	: info_to_up.isActive,// ? 'true' : 'false',
						isSound     : info_to_up.isSound,
						isPopup 	: info_to_up.isPopup,
						timeout 	: info_to_up.timeout,
						
					}
					const api = this.$URL_face + '/api/face/ruleaccess/create';
					
					axios.post(api, info_update).then( res => {
						this.$EventBus.$emit('notifications_modal', {
							type: 'saved',
						} )
						this.show = false;
						/*this.$emit('is_show', false);
						this.$emit('is_actions', false);
						this.$emit('edit_item', {});*/
						if (this.list.length === 0) {
							 this.get_list();	
						}else{
							this.list.push(info_update);
						}
						this.save_local();
					}).catch( er => {
						console.log(er, 'error update sz contacts');
					})
			
			},
			update(val, from){
				let vl 			= null;
				let info_to_up 	= null;
				if (from !== 'settings') {
					vl 			= val.id;
					info_to_up 	= val;
				}else{
					vl 			= val.id;
					info_to_up 	= this.info;
				}
				if ((info_to_up.isAccess || !info_to_up.isAccess) && from == 'access') {
					info_to_up.isAccess = !info_to_up.isAccess
				}
				if ((info_to_up.isActive || !info_to_up.isActive) && from == 'active') {
					info_to_up.isActive = !info_to_up.isActive;
				}
				if ((info_to_up.isSound || !info_to_up.isSound) && from == 'sound') {
					info_to_up.isSound = !info_to_up.isSound
				}
				if ((info_to_up.isPopup || !info_to_up.isPopup) && from == 'popup') {
					info_to_up.isPopup = !info_to_up.isPopup;
				}
				let info_update = {
					entity 		: info_to_up.entity,
					host 		: info_to_up.host,
					isAccess 	: info_to_up.isAccess,// ? 'true' : 'false',
					isActive 	: info_to_up.isActive,// ? 'true' : 'false',
					isSound 	: info_to_up.isSound,
					isPopup 	: info_to_up.isPopup,
					timeout 	: info_to_up.timeout,
					
				}
				console.log(val, info_to_up, info_update, 'info to update')
				const api = this.$URL_face + '/api/face/ruleaccess/' + vl;

				
				axios.put(api, info_update).then( res => {
					this.$EventBus.$emit('notifications_modal',{
						type: 'updated',
					})
					let items = this.list;
					// let this.list=items.indexOf(val);
					// this.list.splice(items.indexOf(val), 1, info_update);
					
					this.list[items.indexOf(val)].timeout = info_to_up.timeout;
					if(from == 'access'){
						this.list[items.indexOf(val)].isAccess = val.isAccess;
						
					}
					if(from == 'active'){
						this.list[items.indexOf(val)].isActive = val.isActive;
						
					}
					if(from == 'sound'){
						this.list[items.indexOf(val)].isSound = val.isSound;
						
					}
					if(from == 'popup'){
						this.list[items.indexOf(val)].isPopup = val.isPopup;
						
					}
					if (from == 'timeout') {
						this.dialog_timer = false;
					}
					if(from == 'settings'){
						
						this.list[items.indexOf(val)].entity 	= info_to_up.entity;				
						this.list[items.indexOf(val)].host 	  	= info_to_up.host;				
						this.list[items.indexOf(val)].isActive 	= info_to_up.isActive == ( 1 || '1') ? true : false;
						this.list[items.indexOf(val)].isAccess 	= info_to_up.isAccess == ( 1 || '1') ? true : false;
						this.list[items.indexOf(val)].isPopup 	= info_to_up.isPopup  == ( 1 || '1') ? true : false;
						this.list[items.indexOf(val)].isSound 	= info_to_up.isSound  == ( 1 || '1') ? true : false;							
						/*this.$emit('is_show', false);
						this.$emit('edit_item', {});
						this.$emit('is_actions', false);	*/				
					}
					// this.get_list();
					this.info 		 = {}; 
					this.update_item = '';
					this.btn_title   = 'save';
					this.save_local(/*this.name_change, info_to_up*/);
					this.show 		 = false;
					// let items=this.list;
				}).catch( er => {
					console.log(er, 'error update alert sound');						
				})
			}, // update
			edit(item){
				// this.show=true;
				this.update_item = item;
				// this.name_change = item.name;
				this.btn_title 	 = 'update';
				/*this.inf.name=item.name;
				this.inf.isSound=item.isSound;
				this.inf.isPopup=item.isPopup;
				let info_to_update
				*/
				this.info = {
					entity 		: item.entity,
					host 		: item.host,
					isAccess 	: item.isAccess == 1 ? true : false,
					isActive 	: item.isActive == 1 ? true : false,
					isSound 	: item.isSound 	== 1 ? true : false,
					isPopup 	: item.isPopup	== 1 ? true : false,
					timeout 	: item.timeout
					
				}
				this.show = true;
				// this.$emit('edit_item', info_to_update);
				// this.$emit('is_show', true);
				// this.$emit('is_to_update', true);

			}, // edit

			edit_timeout(item){
				this.dialog_timer = true;
				this.update_item = item;
			}, // edit timeout

			del(item){
				this.del_item = item;
				eventBus.$emit('notifications_modal',{
					type: 'confirm_delete',
					ID: 'access_rules'
				})
				/*this.info_to_modal = { 
					dialog: true, 
					type: true,
				}*/
			}, // del

			confirm_del(val){
				if(val){
					this.info_to_modal = null;
					const api = this.$URL_face + '/api/face/ruleaccess/' + this.del_item.id + '/delete';
					
					axios.delete(api).then( res => {
						this.$EventBus.$emit('notifications_modal', {
							type: 'deleted',
						})
						
						console.log(this.del_item, 'item to del', val)					
						this.list.splice(this.list.indexOf(this.del_item), 1);
						this.save_local();
					}).catch ( er => {
						console.log(er, 'error delete item category')
					})
				}
			}, // confirm del

			save_local(name='',  from){
				let list_t 		= [], 
					list_temp 	= this.list, 
					up_name 	= false;
			
					list_t = list_temp;
				// }
				console.log(list_t, 'save end ')
				const inf_to_local = JSON.stringify(list_t);
				localStorage.setItem('access_rules', inf_to_local);				
				eventBus.$emit('render_access_rules', list_temp)
			}, // save local

			close_inf(){
				
			}, // close_inf

			render_device(val){
				if (this.list_devices && this.list_devices.length > 0) {
					let vm 	   = this,
						device = ''	;

					const find = vm.list_devices.some( function (dev, idx_dev){
						if (dev.deviceId == val) {
							device = dev.name;
							return true
						}
					}) 

					return device;
				}
				return '';
			}, // render_device
		}, // methods		

		computed:{
			render_list: function(){
				return this.list;
			}, // render list
			
		}, // computed

		mounted(){

			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}


			eventBus.$on('notifications_modal' + 'access_rules', (action) =>{
				if (action) {
					this.confirm_del(action)
				}
			});
		}, // mounted
	}; 
</script>